import React from "react";
import { Dialog } from "../../../bits/Dialog/Dialog";
import { DatePicker } from "../../../bits/DatePicker/DatePicker";
import Alert from "../../../bits/Alert/Alert";

interface TimeOffDialogProps {
    open: boolean;
    onClose: () => void;
    draftVacation: any;
    setDraftVacation: (data: any) => void;
    onSave: () => void;
}

export default function TimeOffDialog({
    open,
    onClose,
    draftVacation,
    setDraftVacation,
    onSave,
}: TimeOffDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            title="Time Off"
            onSave={onSave}
            onCancel={onClose}
            saveText="Save time off period"
            cancelText="Cancel"
        >
            <div className="v2-form">
                <Alert type="info">
                    Use this to book your time off. When you book time off days, the
                    intake team will see you as unavailable on those days.
                </Alert>

                <DatePicker
                    label="From"
                    selected={draftVacation.startingDate}
                    onChange={(date) => {
                        if (date) {
                            const newStartingDate = date as Date;
                            const isEndingBeforeStart =
                                draftVacation.endingDate < newStartingDate;
                            setDraftVacation({
                                ...draftVacation,
                                startingDate: newStartingDate,
                                endingDate: isEndingBeforeStart
                                    ? newStartingDate
                                    : draftVacation.endingDate,
                            });
                        }
                    }}
                    popperProps={{
                        strategy: "fixed",
                        modifiers: [
                            {
                                name: "zIndex",
                                options: {
                                    zIndex: 99999,
                                },
                            },
                        ],
                    }}
                />

                <DatePicker
                    label="Until"
                    selected={draftVacation.endingDate}
                    minDate={draftVacation.startingDate}
                    onChange={(date) => {
                        if (date) {
                            setDraftVacation({
                                ...draftVacation,
                                endingDate: date as Date,
                            });
                        }
                    }}
                    popperProps={{
                        strategy: "fixed",
                        modifiers: [
                            {
                                name: "zIndex",
                                options: {
                                    zIndex: 99999,
                                },
                            },
                        ],
                    }}
                />
            </div>
        </Dialog>
    );
}
